<template>
  <transition name="ashe-fade">
    <div class="ashe-share" @click.self="visibleSync = false" v-show="visibleSync" @touchmove.self.prevent="">
      <transition name="ashe-slideInUp">
        <div class="box" v-show="visible">
          <div class="box-slot" v-if="$slots.default">
            <div class="box-content-title">
              <p>{{ titleForWay }}</p>
              <div class="box-content-sub" v-if="subTitleForWay">
                {{ subTitleForWay }}
              </div>
            </div>
            <div class="box-slot-content">
              <slot />
            </div>
          </div>
          <div class="box-content" @click.stop.prevent="">
            <div class="box-content-title">
              <p>{{ title }}</p>
              <div class="box-content-sub" v-if="subTitle">
                {{ subTitle }}
              </div>
            </div>
            <div class="box-content-channels">
              <div class="box-content-channels_item" v-for="(channel, index) of channelsFormat" :key="channel.value">
                <transition :name="`ashe-share-bounce-${index}`">
                  <div class="box-content-channel" @click="handler(channel.value)" v-show="visible">
                    <img :src="channel.imgUrl" />
                    <span>{{ channel.text }}</span>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="box-split" />
          <div class="box-btn-cancel" @click="visibleSync = false">取消</div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import bridge from "@clover/bridge";
import IMG_WEIXIN from "./assets/weixin.png";
import IMG_WEIXIN_CIRCLE from "./assets/weixin_friend.png";
import IMG_QQ from "./assets/qq.png";
import IMG_QZONE from "./assets/qzone.png";
import IMG_WEIBO from "./assets/weibo.png";
import IMG_SOUL from "./assets/souler.png";
import IMG_SQUARE from "./assets/src_share_assets_square.png";
import { isSoul } from "@/libs/lib";
import { sendLog } from "@/libs/sendLog";
function isPromise(obj) {
  return Object.prototype.toString.call(obj) === "[object Promise]";
}

export default {
  name: "ashe-share",

  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },

    title: {
      type: String,
      default: "分享到",
    },

    subTitle: String,

    titleForWay: {
      type: String,
      default: "分享方式",
    },

    subTitleForWay: String,

    channels: {
      type: String,
      default: "WEIXIN,WEIXIN_CIRCLE,QQ,QZONE,WEIBO,SOUL,SQUARE",
    },

    callback: {
      type: Function,
      required: true,
    },

    closeAfterClick: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      dict: [
        {
          value: "WEIXIN",
          imgUrl: IMG_WEIXIN,
          text: "微信",
        },
        {
          value: "WEIXIN_CIRCLE",
          imgUrl: IMG_WEIXIN_CIRCLE,
          text: "朋友圈",
        },
        {
          value: "QQ",
          imgUrl: IMG_QQ,
          text: "QQ",
        },
        {
          value: "QZONE",
          imgUrl: IMG_QZONE,
          text: "QQ空间",
        },
        {
          value: "WEIBO",
          imgUrl: IMG_WEIBO,
          text: "微博",
        },
        {
          value: "SOUL",
          imgUrl: IMG_SOUL,
          text: "Souler",
        },
        {
          value: "SQUARE",
          imgUrl: IMG_SQUARE,
          text: "广场",
        },
      ],
      clickLock: false,
    };
  },
  computed: {
    visibleSync: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    channelsFormat() {
      return this.channels
        .split(",")
        .reduce((prev, curr) => [...prev, this.dict.find((item) => item.value === curr)], [])
        .filter((i) => {
          if (isSoul() && i?.value === "SQUARE") {
            return bridge.compareVersion(bridge.getAppVersion(), "4.55.0") <= 0;
          }
          return !!i;
        });
    },
  },
  methods: {
    handleShare(platform, params) {
      if (platform === "SQUARE") {
        bridge.dispatch("action_event_launchPublish", {
          content: params.postContent || null,
          path: params.type === "IMAGE" ? params.fileUrl : null,
          tags: params.tags || [],
          square: {
            bizNewType: 4,
            bizId: 0,
            bizJson: JSON.stringify({
              title: params.title,
              subTitle: params.desc,
              thumbImage: params.thumb,
              jumpURL: params.url,
            }),
          },
        });
      } else {
        bridge.share({ platform, ...params });
      }

      sendLog("clk", "Click_Operation_Activity_Share_Channel", {
        trigger: "navbar",
        activity_page_id: window.__page_id,
        channel: platform,
      });
    },
    handler(channel = "") {
      if (this.clickLock) return;
      this.clickLock = true;

      const result = this.callback(channel);
      const callback = (data) => {
        this.handleShare(channel, data);
      };

      if (isPromise(result)) {
        result.then((data) => callback(data));
      } else {
        callback(result);
      }

      this.visibleSync = false;
      setTimeout(() => (this.clickLock = false), 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.ashe-share {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);

  * {
    user-select: none;
    -webkit-touch-callout: none;
  }

  .box {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 32px 0 0;
    text-align: center;
    border-radius: 24px 24px 0 0;
    background-color: #fefefe;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    &-split {
      height: 16px;
      background-color: #ededed;
    }

    &-slot {
      &-content {
        padding: 40px 48px 20px;
      }
    }

    &-content {
      width: 100%;
      padding: 0 0 64px;
      overflow: hidden;

      &-title {
        color: #282828;
        font-size: 32px;
        line-height: 50px;
      }

      &-sub {
        font-size: 28px;
        line-height: 40px;
      }

      &-channels {
        display: flex;
        flex-wrap: nowrap;
        padding-top: 40px;
        padding-left: 48px;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          display: none;
          background-color: transparent;
        }
      }

      &-channel {
        margin-right: 60px;

        &:last-child {
          margin-right: 48px;
        }

        img {
          display: block;
          width: 96px;
          height: 96px;
          margin: 0 auto;
          margin-bottom: 16px;
        }

        span {
          display: block;
          color: #282828;
          font-size: 28px;
          line-height: 28px;
          white-space: nowrap;
        }
      }
    }

    &-btn-cancel {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 112px;
      color: #282828;
      font-size: 32px;
    }
  }

  @for $i from 0 through 6 {
    &-bounce-#{$i} {
      &-enter-active {
        animation: bounce-in 0.5s ease-in-out #{$i * 0.05}s;
      }
    }
  }
}

@keyframes bounce-in {
  0% {
    transform: translate3d(0, 8px, 0);
  }

  50% {
    transform: translate3d(0, -32px, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.ashe-fade-enter-active,
.ashe-fade-leave-active {
  transition: opacity 300ms;
}

.ashe-fade-enter-from,
.ashe-fade-leave-to {
  opacity: 0;
}

.ashe-slideInUp-enter-active,
.ashe-slideInUp-leave-active {
  transition: transform 300ms;
}

.ashe-slideInUp-enter-from,
.ashe-slideInUp-leave-to {
  transform: translate3d(0, 100%, 0);
}
</style>
